<template>
  <div class="recharge-first">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <!-- 这是黑色返回箭头 -->
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="recharge-content">
      <img v-if="$i18n.locale === 'ar'" class="rec-fir-tit" src="./images/title-ar.png" alt="" />
      <img v-else-if="$i18n.locale === 'es'" class="rec-fir-tit" src="./images/title-es.png" alt="" />
      <img v-else-if="$i18n.locale === 'pt'" class="rec-fir-tit" src="./images/title-pt.png" alt="" />
      <img v-else class="rec-fir-tit" src="./images/title-en.png" alt="" />
      <div class="rec-fir-date">
        {{ $t('lang.commonM.k083') }}
        <img src="./images/clock.png" />
        {{ showTime }}
      </div>

      <div class="rec-fir-con">
        <div class="rec-fir-block">
          <div class="rec-fir-reward">
            <div class="fir-reward-l">
              <span class="fir-reward-tit">{{ $t('lang.commonM.k084') }}</span>
              <img class="fir-reward-coin" :src="getMatchImg('coin')" alt="" />
              <span v-if="baseInfo" class="fir-reward-num">{{ baseInfo.originAmount }}</span>
              <span v-if="baseInfo" class="fir-reward-price">{{ baseInfo.currency }}{{ handleDiv100(baseInfo.originPrice) }}</span>
            </div>
            <img v-if="baseInfo && baseInfo.discountDesc === '40%'" class="fir-reward-c" src="./images/up-f.png" />
            <img v-if="baseInfo && baseInfo.discountDesc === '30%'" class="fir-reward-c" src="./images/up-t.png" />
            <div class="fir-reward-r">
              <span class="fir-reward-tit">{{ $t('lang.commonM.k085') }}</span>
              <img class="fir-reward-coin" :src="getMatchImg('coins')" alt="" />
              <span v-if="baseInfo" class="fir-reward-num">{{ baseInfo.amount }}</span>
              <span v-if="baseInfo" class="fir-reward-price">{{ baseInfo.currency }}{{ handleDiv100(baseInfo.price) }}</span>
            </div>
          </div>

          <div class="rec-fir-deliver">
            <div class="deliver-l">
              <div></div>
            </div>
            {{ $t('lang.commonM.k086') }}
            <div class="deliver-r">
              <div></div>
            </div>
          </div>

          <div class="rec-fir-fecture">
            <div class="fir-fecture-item">
              <img src="./images/video.png" alt="" />
              <div>
                <span>{{ $t('lang.commonM.k087') }}</span>
                <span>{{ $t('lang.coupon.extra') }} x{{ matchPassExtra }}</span>
              </div>
            </div>
            <div class="fir-fecture-item">
              <img src="./images/message.png" alt="" />
              <div>
                <span>{{ $t('lang.commonM.k088') }}</span>
                <span>{{ $t('lang.coupon.extra') }} x{{ superChatPassExtra }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="rec-fir-btn" :class="{ 'cannot-claim': !baseInfo || !baseInfo.ifValid }" @click="handleClaim">
      <span>{{ $t('lang.commonM.k089') }}</span>
    </div>

    <ul class="rec-fir-tip">
      <li>
        <MyPLabel :str="$t('lang.commonM.k090')" :numsOption="[{ value: randowCount }]" />
      </li>
    </ul>
  </div>
</template>

<script>
// 充值9.99、19.99额外获得金币活动
import { firstRechargeApi } from './apidir/api.js'
export default {
  data() {
    return {
      appInfo: null,
      // 倒计时
      lastTime: 0,
      endTime: 0,
      showTime: '00:00:00',
      // 随机count
      randowCount: 10908,
      baseInfo: null,
      matchPassExtra: 0,
      superChatPassExtra: 0
    }
  },
  methods: {
    handleClaim() {
      if (!this.baseInfo || !this.baseInfo.ifValid) {
        return
      }
      // 支付基础参数
      const payQuery = {
        scene: 'activity',
        activityType: 7,
        gid: this.baseInfo.gid,
        productId: this.baseInfo.productId,
        amount: this.baseInfo.amount,
        backType: 'previous'
      }

      // todo-修改前
      // const appVerionsLimit = this.compareVersion(this.appInfo.version, '4.2.1')
      // const appChannel = this.getChannel()
      // if (appChannel === 'vvg' && appVerionsLimit > 0) {
      //   payQuery.useWebPay = '1'
      //   payQuery.price = this.handleDiv100(this.baseInfo.price)
      //   payQuery.currency = this.baseInfo.currency
      // }

      // this.traceAction({ Action: 'Click', APosition: 'button', AValue: 'first-recharge-click-claim' })

      // this.$router.push({
      //   path: '/pay',
      //   query: payQuery
      // })

      // todo-修改后
      // price currency参数控制 原生支付的显示
      // 下面这些版本之后，payGoogleFromWeb 才支持服务端需要回传的avtivityType
      const appChannel = this.getChannel()
      if (appChannel === 'vvg') {
        const appVerionsLimit = this.compareVersion(this.appInfo.version, '4.2.1')
        if (appVerionsLimit > 0) {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      }
      if (appChannel === 'jcg') {
        const appVerionsLimit = this.compareVersion(this.appInfo.version, '2.3.0')
        if (appVerionsLimit > 0) {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      }
      if (appChannel === 'eca') {
        const appVerionsLimit = this.compareVersion(this.appInfo.version, '1.2.1')
        if (appVerionsLimit > 0) {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      }
      if (appChannel === 'ecg') {
        const appVerionsLimit = this.compareVersion(this.appInfo.version, '1.3.0')
        if (appVerionsLimit > 0) {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      }

      this.traceAction({ Action: 'Click', APosition: 'button', AValue: 'first-recharge-click-claim' })

      if (appChannel === 'eca' || appChannel === 'ecg') {
        this.$router.push({
          path: '/echo-pay',
          query: payQuery
        })
        return
      }

      this.$router.push({
        path: '/pay',
        query: payQuery
      })
    },
    // 获得页面数据
    initData() {
      firstRechargeApi().then((resData) => {
        this.baseInfo = resData

        if (this.baseInfo && this.baseInfo.presentPropList && this.baseInfo.presentPropList.length) {
          let matchObj = this.baseInfo.presentPropList.find((ele) => ele.propType === 2)
          if (matchObj) {
            this.matchPassExtra = matchObj.number
          }

          let superObj = this.baseInfo.presentPropList.find((ele) => ele.propType === 15)
          if (superObj) {
            this.superChatPassExtra = superObj.number
          }
        }
        // 初始化倒计时
        try {
          let now = Date.now()
          this.endTime = now + resData.expireSeconds * 1000
          this.startCountdown(now)
        } catch (err) {
          this.showTime = ''
        }
      })
    },
    refreshData() {
      if (this.baseInfo) {
        this.baseInfo.ifValid = false
      }
    },
    initRandomCount() {
      // 30分钟
      const intervalTime = 1800000
      // const intervalTime = 3000
      const uid = this.getUid()
      const loop = () => {
        // 10908-20908
        let random = Math.floor((Math.random() + 1) * 10000) + 908
        let nowTime = Date.now()

        let storeObj = window.localStorage.getItem(`randowCount${uid}`)
        // 有缓存
        if (storeObj) {
          try {
            storeObj = JSON.parse(storeObj)
            random = storeObj.count * 1
            nowTime = storeObj.time * 1

            const currentTime = Date.now()
            if (currentTime - nowTime >= intervalTime) {
              let willNum = random + 118
              if (willNum > 99999) {
                willNum = 100000
              }
              window.localStorage.setItem(`randowCount${uid}`, JSON.stringify({ count: willNum, time: currentTime }))
            }
          } catch (err) {
            console.log('try catch', err)
          }
        }
        // 没缓存
        else {
          window.localStorage.setItem(`randowCount${uid}`, JSON.stringify({ count: random, time: nowTime }))
        }

        this.randowCount = random > 99999 ? '99999+' : random

        setTimeout(() => {
          loop()
        }, 10000)
      }

      loop()
    },
    startCountdown() {
      const countdownFn = (currentTime) => {
        // 避免过于频繁的更新
        if (currentTime - this.lastTime >= 1000) {
          const remainingTime = this.endTime - Date.now()

          if (remainingTime <= 0) {
            this.showTime = '00:00:00'
            this.refreshData()
            return
          }

          this.showTime = `${this.formatTime(remainingTime)}`
          this.lastTime = currentTime
        }

        // 继续下一帧
        this.animationFrameId = requestAnimationFrame(countdownFn)
      }

      this.animationFrameId = requestAnimationFrame(countdownFn)
    },
    // 格式化时间显示
    formatTime(ms) {
      if (ms <= 0) return '00:00:00'

      const totalSeconds = Math.floor(ms / 1000)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    }
  },
  created() {
    this.appInfo = this.$client.getAppInfo() || { version: '' }
    this.initData()
    this.initRandomCount()

    this.traceAction({ Action: 'Click', APosition: 'entrance', AValue: 'first-recharge' })
  }
}
</script>

<style lang="scss" scoped>
.recharge-first {
  width: 375px;
  min-height: 100vh;
  background: linear-gradient(180deg, #c6ffec 0%, #d9feff 100%);
  .custom-nav-block {
    background: linear-gradient(180deg, #c6ffec 0%, #d9feff 100%) left top / 100% 100vh no-repeat;
  }

  .recharge-content {
    .rec-fir-tit {
      display: block;
      width: 315px;
      height: 96px;
      margin: 6px auto 0;
    }

    .rec-fir-date {
      width: 343px;
      height: 28px;
      margin: 13px auto 0;
      background: linear-gradient(90deg, rgba(212, 255, 243, 0) 0%, #ecffc7 24%, rgba(236, 255, 199, 0.91) 77%, rgba(212, 255, 243, 0) 100%);

      display: flex;
      align-items: center;
      justify-content: center;

      font-family: RobotoFlex-Regular;
      font-size: 17px;
      color: #ffc900;

      img {
        width: 28px;
        height: 28px;
        margin: 0 6px;
      }
    }

    .rec-fir-con {
      width: 343px;
      height: 336px;
      margin: 24px auto 0;
      padding-top: 10px;
      background: linear-gradient(90deg, #d5ff5a 0%, #5ce8fa 100%);
      border-radius: 16px;
      .rec-fir-block {
        width: 343px;
        height: 100%;
        padding: 0 10px;
        background: #ffffff;
        border-radius: 16px;

        .rec-fir-reward {
          display: flex;
          justify-content: space-between;
          position: relative;
          .fir-reward-l {
            width: 140px;
            height: 170px;
            margin-top: 30px;
            background: linear-gradient(90deg, #edffff 0%, #f4fdfb 100%);
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .fir-reward-tit {
              font-family: RobotoFlex-Regular;
              font-size: 17px;
              color: #6f8596;
              line-height: 20px;
            }
            .fir-reward-coin {
              width: 36px;
              height: 36px;
              margin-top: 10px;
            }
            .fir-reward-num {
              height: 40px;
              font-family: RobotoFlex-Regular;
              font-size: 32px;
              color: #6f8596;
              line-height: 40px;
              margin-top: 10px;
            }
            .fir-reward-price {
              height: 20px;
              font-family: RobotoFlex-Regular;
              font-size: 17px;
              color: #6f8596;
              line-height: 20px;
              margin-top: 6px;
            }
          }
          .fir-reward-c {
            width: 90px;
            height: 90px;
            position: absolute;
            top: 80px;
            left: 50%;
            margin-left: -45px;
          }
          .fir-reward-r {
            width: 140px;
            height: 180px;
            margin-top: 20px;
            background: linear-gradient(90deg, #ffecd1 0%, #fff9e2 100%);
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .fir-reward-tit {
              font-family: RobotoFlex-Regular;
              font-size: 20px;
              color: #a74b0d;
              line-height: 20px;
            }
            .fir-reward-coin {
              width: 60px;
              height: 60px;
              margin-top: 6px;
            }
            .fir-reward-num {
              height: 40px;
              font-family: RobotoFlex-Regular;
              font-size: 40px;
              color: #a74b0d;
              line-height: 40px;
            }
            .fir-reward-price {
              height: 20px;
              font-family: RobotoFlex-Regular;
              font-size: 20px;
              color: #a74b0d;
              line-height: 20px;
              margin-top: 6px;
            }
          }
        }

        .rec-fir-deliver {
          margin-top: 24px;
          font-family: RobotoFlex-Regular;
          font-size: 17px;
          color: #333333;
          height: 20px;
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          .deliver-l,
          .deliver-r {
            flex: 1;
            position: relative;
          }
          .deliver-l {
            div {
              width: 100%;
              height: 1px;
              background: #d4dfe4;
            }
          }
          .deliver-r {
            div {
              width: 100%;
              height: 1px;
              background: #d4dfe4;
            }
          }
        }

        .rec-fir-fecture {
          margin-top: 24px;
          padding: 0 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .fir-fecture-item {
            display: flex;
            align-items: center;
            gap: 8px;
            img {
              width: 30px;
              height: 30px;
            }
            div {
              span {
                display: block;
                &:first-child {
                  font-family: RobotoFlex-Regular;
                  font-size: 14px;
                  color: #333333;
                  line-height: 16px;
                }
                &:last-child {
                  font-family: RobotoFlex-Regular;
                  font-size: 12px;
                  color: #8e8e96;
                  line-height: 14px;
                  margin-top: 4px;
                }
              }
            }
          }
        }
      }
    }
  }

  .rec-fir-btn {
    width: 283px;
    height: 54px;
    margin: 40px auto 0;
    background: #ffe75c;
    border-radius: 27px;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: RobotoFlex-Regular;
    font-size: 20px;
    color: #333333;
    line-height: 24px;
  }
  .cannot-claim {
    pointer-events: none;
    background: #dbdbdb;
    color: #999999;
  }
  .rec-fir-tip {
    width: 100%;
    padding: 0 16px 40px;
    font-family: RobotoFlex-Regular;
    font-size: 15px;
    color: #79adab;
    line-height: 18px;
    margin-top: 12px;
    li {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
